import * as actionTypes from 'constants/ActionTypes';

export function getVesselSizes() {
    return {
        type: actionTypes.GET_VESSEL_SIZES,
    };
}

export function createVesselSizes(items) {
    return {
        type: actionTypes.CREATE_VESSEL_SIZES,
        items,
    };
}

export function addVesselSize() {
    return {
        type: actionTypes.ADD_VESSEL_SIZE,
    };
}

export function updateVesselSize(numberSize, newVesselSize) {
    return {
        type: actionTypes.UPDATE_VESSEL_SIZE,
        numberSize,
        newVesselSize,
    };
}

export function updateVesselSizeUser(user) {
    return {
        type: actionTypes.UPDATE_VESSEL_SIZE_USER,
        user,
    };
}

export function removeLastVesselSize() {
    return {
        type: actionTypes.REMOVE_LAST_VESSEL_SIZE,
    };
}

export function removeAllVesselSize() {
    return {
        type: actionTypes.REMOVE_ALL_VESSEL_SIZES,
    };
}

export function notificationPurposeRequired() {
    return {
        type: actionTypes.NOTIFICATION_PURPOSE_REQUIRED,
    };
}

// TOT update vessel order user


// WEBPACK FOOTER //
// ./app/actions/vessels/size.js